import { Button, Col, Form, Row, Select, Input } from "antd";
import { useEffect, useState, useLayoutEffect } from "react";
import { useSearchParams } from "react-router-dom";
import styled from "styled-components";
import { useAppSelector } from "../../../hooks/useAppSelector";
import { SLOT_CONFIG } from "../../../common/constants";

const StyledFilterContainer = styled.div`
  &,
  & .filter {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;

    &__item {
      margin: 0.5rem;

      & .ant-form-item {
        margin: 0;
      }

      &--submit {
        align-self: flex-end;
      }
    }
  }
`;

export const AppAvailableOrdersConfigFilter = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [form] = Form.useForm();
    const { darkStores } = useAppSelector((state) => state.adminServices);

    // Sync form with searchParams whenever they change
    useEffect(() => {
        const params = Object.fromEntries(new URLSearchParams(searchParams));
        const formValues = {
            slotId: params.slotId || undefined,
            storeId: params.storeId ? parseInt(params.storeId) : undefined,
        };

        form.setFieldsValue(formValues);
    }, [form, searchParams]);

    // Ensure form is synced on mount (before paint) to prevent empty fields on expand
    useLayoutEffect(() => {
        const params = Object.fromEntries(new URLSearchParams(searchParams));
        const formValues = {
            slotId: params.slotId || undefined,
            storeId: params.storeId ? parseInt(params.storeId) : undefined,
        };

        form.setFieldsValue(formValues);
    }, []);

    const onSearch = async (values: Record<string, any>) => {
        try {
            // Validate form before proceeding
            await form.validateFields();

            const params: Record<string, string> = {};

            if (values.storeId) {
                params.storeId = String(values.storeId);
            }

            if (values.slotId) {
                params.slotId = String(values.slotId);
            }

            setSearchParams(params);
        } catch (error) {
            // Form validation failed
            console.error('Validation failed:', error);
        }
    };

    return (
        <StyledFilterContainer>
            <Form
                form={form}
                name="available-orders-config-filter-form"
                onFinish={onSearch}
                layout="vertical"
                style={{ width: "100%" }}
            >
                <Row className="filter">
                    <Col xs={20} sm={4} md={5} lg={4} className="filter__item">
                        {darkStores && <Form.Item name="storeId" label="Store ID" required={false} >
                            <Select placeholder="Search by Store ID" size="small" allowClear showSearch onClear={() => {
                                form.submit();
                            }}>
                                {(darkStores).map((e) => (
                                    <Select.Option value={e.id} key={e.id}>
                                        {e.name} || {e.id}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>}
                    </Col>

                    <Col xs={20} sm={4} md={5} lg={4} className="filter__item">
                        <Form.Item name="slotId" label="Slot">
                            <Select
                                placeholder="Select a slot"
                                size="small"
                                allowClear
                                showSearch
                                onClear={() => {
                                    form.submit();
                                }}
                            >
                                {Object.entries(SLOT_CONFIG).map(([id, slotName]) => (
                                    <Select.Option value={parseInt(id)} key={id}>
                                        {id} - {slotName}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col
                        xs={20}
                        sm={4}
                        md={2}
                        lg={2}
                        className="filter__item filter__item--submit"
                    >
                        <Form.Item>
                            <Button type="primary" htmlType="submit" size="small">
                                Search
                            </Button>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </StyledFilterContainer>
    );
};
